import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ForwardGeocodingQueryVariables = Types.Exact<{
  text: Types.Scalars['String'];
}>;


export type ForwardGeocodingQuery = { __typename?: 'Query', forwardGeocode: Array<{ __typename?: 'GeoPlace', name: string, coordinates: { __typename?: 'Coordinate', lat?: number | null, lng?: number | null } }> };


export const ForwardGeocodingDocument = gql`
    query ForwardGeocoding($text: String!) {
  forwardGeocode(text: $text) {
    name
    coordinates {
      lat
      lng
    }
  }
}
    `;

/**
 * __useForwardGeocodingQuery__
 *
 * To run a query within a React component, call `useForwardGeocodingQuery` and pass it any options that fit your needs.
 * When your component renders, `useForwardGeocodingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForwardGeocodingQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useForwardGeocodingQuery(baseOptions: Apollo.QueryHookOptions<ForwardGeocodingQuery, ForwardGeocodingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForwardGeocodingQuery, ForwardGeocodingQueryVariables>(ForwardGeocodingDocument, options);
      }
export function useForwardGeocodingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForwardGeocodingQuery, ForwardGeocodingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForwardGeocodingQuery, ForwardGeocodingQueryVariables>(ForwardGeocodingDocument, options);
        }
export type ForwardGeocodingQueryHookResult = ReturnType<typeof useForwardGeocodingQuery>;
export type ForwardGeocodingLazyQueryHookResult = ReturnType<typeof useForwardGeocodingLazyQuery>;
export type ForwardGeocodingQueryResult = Apollo.QueryResult<ForwardGeocodingQuery, ForwardGeocodingQueryVariables>;